import {useNavigate} from "react-router-dom";
import {Button, Empty, Form, Input, NavBar, Toast} from "antd-mobile";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {userCheck} from "../../common/ApiAction";

const ORDER_STATUS_MAP: Record<number, string> = {
    0: "WaitConfirm",
    1: "Normal",
    2: "PayOff",
    3: "Default",
    4: "Return Phone",
    5: "Early Settlement",
    6: "Special Repayment",
    7: "Not Pass",
    8: "Cancel",
};

const CheckUser = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [list, setList] = useState<any[]>([]);

    const back = () => {
        navigate(-1);
    };
    const onFinish = (values: any) => {
        console.log(values);
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        userCheck(values.mobile, values.idNum).then((res: any) => {
            Toast.clear();
            if (res.executed) {
                setList(res.data);
            }
        }).catch(err => {
            console.log(err);
            Toast.clear();
        })
    }
    const _renderItem = (title: string, value: string, needTop: boolean = true) => {
        return <div style={needTop ? {marginTop: 5, display: "flex", flexDirection: "row", justifyContent: 'space-between', alignItems: "center"} : {display: "flex", flexDirection: "row", justifyContent: 'space-between', alignItems: "center"}}>
            <span>{title}</span>
            <span>{value}</span>
        </div>
    }
    const _renderList = () => {
        if (list.length) {
            return <div style={{backgroundColor: '#FFF', margin: '10px', borderRadius: '5px'}}>
                {list.map((item, index) => (
                    <div key={index} style={{padding: '10px', display: 'flex', flexDirection: 'column'}}>
                        {_renderItem(t('create_order_user_name'), item.userName, false)}
                        {_renderItem(t('create_order_user_mobile'), item.mobile)}
                        {_renderItem(t('create_order_id_number'), item.idNum)}
                        {_renderItem(t('create_order_product_name'), item.model)}
                        {_renderItem(t('create_order_product_serial_number'), item.appleId)}
                        {_renderItem(t('common_ordere_no'), item.orderNo)}
                        {_renderItem(t('common_status'), ORDER_STATUS_MAP[item.orderStatus] ?? "unknown status")}
                    </div>
                ))}
            </div>
        }
        return <div>
            <Empty description='No Data'/>
        </div>
    }
    return (
        <div style={{display: "flex", flexDirection: "column", width: '100%', backgroundColor: '#F5F6FA'}}>
            <NavBar style={{backgroundColor: '#FFF'}} onBack={back}>{t('check_user_title')}</NavBar>
            <div>
                <Form
                    onFinish={onFinish}
                    mode={'card'}
                    form={form}
                    requiredMarkStyle='asterisk'
                    footer={<Button shape='rounded' type='submit' block color='primary' size='middle'>{t('create_order_submit')}</Button>}>
                    <Form.Header>{t('create_order_user_info')}</Form.Header>
                    <Form.Item name='mobile' label={t('create_order_user_mobile')} rules={[{ required: true, message: t('create_order_required') }]}>
                        <Input placeholder={t('create_order_required')} />
                    </Form.Item>
                    <Form.Item name='idNum' label={t('create_order_id_number')}>
                        <Input placeholder={t('create_order_required')} />
                    </Form.Item>
                </Form>
            </div>
            {_renderList()}
        </div>
    )
}
export default CheckUser
